import { useCallback, useEffect, useState } from 'react';
import DashboardSection from '../../../global/DashboardSection';
import useNavigateWithSearch from '../../../../../hooks/useNavigateWithSearch';
import { getGenericError } from '../../../utils/errors';
import { getGiftCardsBrands } from '../../../utils/service';
import {
  ANCHOR_GIFT_CARDS,
  BRAND_ID_ROUTE_PARAM, ROUTE_GIFT_CARDS, ROUTE_GIFT_CARDS_BRAND_ID,
} from '../../../config/routes';
import { getTrackerId, POSTHOG_CAPTURE_ATTRIBUTES, TRACKER_IDS } from '../../../config/tracker';
import GiftCardItem from '../GiftCardItem';

import './GiftCardsPreviewList.scss';
import { Button, BUTTON_SIZE, BUTTON_TYPE } from '../../../global/Button';
import { isMobile } from '../../../../../hooks/useBreakPoint';

const PREVIEW_ITEMS = 6;

const {
  dashboard: {
    earnTrashiecash: {
      viewAllButton: trackerViewAllButton,
    },
  },
} = TRACKER_IDS;

const GiftCardsPreviewList = ({
  title,
  allowContained = true,
  className,
}) => {
  const navigateWithSearch = useNavigateWithSearch();
  const mobile = isMobile();

  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  const loadGiftCards = useCallback(async () => {
    setIsLoading(true);

    const {
      data,
      error: giftCardsError,
    } = await getGiftCardsBrands({
      pageSize: PREVIEW_ITEMS,
      page: 1,
    });

    if (giftCardsError) {
      setListData([]);
      setError(giftCardsError.message || getGenericError());
      setIsLoading(false);
      return;
    }

    setError('');
    setListData(data.brands);
    setIsLoading(false);
  }, []);

  const handleOnClick = useCallback(({ uid }) => {
    const relativePath = ROUTE_GIFT_CARDS_BRAND_ID.replace(BRAND_ID_ROUTE_PARAM, uid);

    navigateWithSearch(relativePath);
  }, [navigateWithSearch]);

  useEffect(() => {
    loadGiftCards();
  }, []);

  return (
    <DashboardSection
      anchor={ANCHOR_GIFT_CARDS}
      title={title}
      isLoading={isLoading}
      error={error}
      noData={listData.length ? undefined : 'No gift cards available at the moment'}
      ctaTrackerProps={{
        [POSTHOG_CAPTURE_ATTRIBUTES.TRACKER_ID]: getTrackerId(trackerViewAllButton),
      }}
      contained={allowContained && !mobile}
      className={className}
    >
      <div className="GiftCardsPreviewList__container">
        {listData.map(giftCardItem => (
          <GiftCardItem
            key={`giftCard-preview-${giftCardItem.uid}`}
            giftCardItem={giftCardItem}
            onClick={handleOnClick}
            containerClassName="GiftCardsPreviewList__item"
          />
        ))}
      </div>
      {listData.length > 0 && (
        <div className="GiftCardsPreviewList__footer">
          <Button
            type={BUTTON_TYPE.LINK_QUINARY}
            size={BUTTON_SIZE.SMALL}
            onClick={() => navigateWithSearch(ROUTE_GIFT_CARDS)}
            className="GiftCardsPreviewList__footer-button"
          >
            View more
          </Button>
        </div>
      )}
    </DashboardSection>
  );
};

export default GiftCardsPreviewList;
